import { useState } from "react";
import validateIconFile from "src/Pages/Company/Dashboard/pages/Widgets/NewLinkForm/validateIconFile";

const useIconFileUpload = (onFileReady: (dataUrl: string) => void) => {
  const [uploadError, setUploadError] = useState<string | null>(null);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const error = await validateIconFile(file);
    if (error) {
      setUploadError(error);
    } else {
      setUploadError(null);
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          onFileReady(event.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  return { uploadError, handleFileUpload };
};

export default useIconFileUpload;
